import { render, staticRenderFns } from "./InsurancesDashboard.vue?vue&type=template&id=392a556a&scoped=true&"
import script from "./InsurancesDashboard.vue?vue&type=script&lang=js&"
export * from "./InsurancesDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InsurancesDashboard.vue?vue&type=style&index=0&id=392a556a&scoped=true&lang=css&"
import style1 from "./InsurancesDashboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392a556a",
  null
  
)

export default component.exports